export default {
  title: 'ใบแจ้งหนี้',
  description: 'จัดการการเรียกเก็บเงินและใบแจ้งหนี้',

  // Labels
  labels: {
    invoice_number: 'เลขที่ใบแจ้งหนี้',
    billed_date: 'วันที่ออกบิล',
    due_date: 'วันครบกำหนด',
    total: 'รวม',
    subtotal: 'ราคาก่อนภาษี',
    vat: 'ภาษีมูลค่าเพิ่ม {{rate}}%',
    balance_due: 'ยอดค้างชำระ',
    paid_amount: 'ชำระแล้ว',
    payment_difference: 'ยอดชำระต่างจากยอดใบแจ้งหนี้ {{currency}}{{amount}}',
    lease: 'สัญญาเช่า',
    customer: 'ลูกค้า',
    unit: 'ห้อง',
    billing_period: 'รอบบิล',
    due_by: 'ครบกำหนด {{date}}',
    signed_at: 'ลงนามเมื่อ',
    lease_option: '{{code}} - {{name}} (ห้อง {{unit}})',
    external_customer_fallback: 'ลูกค้า #{{id}}',
  },

  // Status
  status: {
    all: 'ใบแจ้งหนี้ทั้งหมด',
    paid: 'ชำระแล้ว',
    unpaid: 'ยังไม่ชำระ',
    overdue: 'เกินกำหนด',
    partially_paid: 'ชำระบางส่วน',
    paid_so_far: 'ชำระแล้ว {{amount}}',
    fully_paid: 'ชำระครบแล้ว',
    payment_overdue: 'เกินกำหนดชำระ',
    payment_due: 'รอชำระ',
  },

  // Item types
  item_types: {
    rent: 'ค่าเช่า',
    water: 'ค่าน้ำ',
    electricity: 'ค่าไฟ',
    internet: 'ค่าอินเทอร์เน็ต',
    common_fee: 'ค่าส่วนกลาง',
    parking: 'ค่าจอดรถ',
    discount: 'ส่วนลด',
    other: 'อื่นๆ',
    common_area_fee: 'ค่าส่วนกลาง',
    late_fee: 'ค่าปรับล่าช้า',
    promotion: 'โปรโมชัน',
    // EP-111: pricing_calculator.rb hardcodes item_type นี้บนทุกบรรทัดค่า
    // ส่วนกลางของเจ้าของร่วมที่มี vat_rate มากกว่า 0
    common_area_fee_vat: 'ภาษีมูลค่าเพิ่มค่าส่วนกลาง',
    // EP-130: รายการที่เกิดจากปุ่มเรียกเก็บเงินประกัน (หรือพิมพ์เอง) ลงบัญชี
    // เป็นหนี้สินเงินประกัน ไม่ใช่รายได้
    deposit: 'เงินประกัน',
    // EP-136: booking_fee เป็นเงินประกัน (หนี้สินเงินประกันเดียวกับ deposit
    // ด้านบน) ส่วน reservation_fee เป็นรายได้ที่ไม่คืนเงิน และไม่นับรวมเป็น
    // เงินประกัน
    booking_fee: 'ค่าจอง',
    reservation_fee: 'ค่าธรรมเนียมการจอง',
  },

  // Payment
  payment: {
    title: 'การชำระเงิน',
    record: 'บันทึกการชำระ',
    sections: {
      advanced: 'รายละเอียดเพิ่มเติม',
    },
    amount: 'จำนวน ({{currency}})',
    method: 'วิธีชำระ',
    date: 'วันที่ชำระ',
    date_before_invoice_warning: 'วันที่นี้อยู่ก่อนวันที่ออกใบแจ้งหนี้ ({{date}})',
    date_future_warning: 'วันที่นี้อยู่ในอนาคต',
    reference: 'หมายเหตุ / อ้างอิง (ไม่บังคับ)',
    reference_placeholder: 'รหัสธุรกรรม, หมายเลขสลิป ฯลฯ',
    confirmed_at: 'วันที่ยืนยันรับเงิน',
    confirmed_at_hint: 'วันที่ยืนยันว่าได้รับเงินแล้ว เว้นว่างหากยังไม่ยืนยัน เมื่อระบุแล้วระบบจะนับยอดชำระนี้เข้ากับใบแจ้งหนี้',
    methods: {
      cash: 'เงินสด',
      transfer: 'โอนเงิน',
      promptpay: 'พร้อมเพย์',
      credit_card: 'บัตรเครดิต',
    },
    enable_method_hint: 'ต้องการวิธีชำระเงินอื่น? เปิดใช้ได้ที่',
    enable_method_link: 'ตั้งค่า → วิธีการชำระเงิน',
    slip: 'สลิป',
    slip_required: 'กรุณาแนบสลิปสำหรับการโอนเงิน',
    // F10/AC-8 (EP-158): the browser's native "Choose File"/"No file
    // chosen" text is OS-locale, not CSS-themeable — FileInput's opt-in
    // overlay (chooseLabel/emptyLabel) replaces it with these.
    slip_choose_file: 'เลือกไฟล์สลิป',
    slip_no_file: 'ยังไม่ได้เลือกไฟล์',
    verified_locked_hint: 'จำนวนเงินและวิธีชำระเงินถูกล็อกเนื่องจากการชำระเงินนี้ตรวจสอบแล้ว หากต้องการแก้ไข ให้ปฏิเสธสลิปก่อน',
    missing_slip: 'ไม่มีสลิป',
    download_receipt: 'ใบเสร็จ',
    delete_confirm: 'ลบการชำระนี้?',
    slip_preview_alt: 'ตัวอย่างสลิป',
    preview_receipt: 'แสดงตัวอย่างใบเสร็จ PDF',
    no_receipt_template: 'ไม่พบเทมเพลตใบเสร็จ กรุณาตั้งค่าใน "ตั้งค่า → เทมเพลต"',
    invoice_not_loaded: 'ใบแจ้งหนี้ยังโหลดไม่เสร็จ กรุณารอสักครู่แล้วลองอีกครั้ง',
  },

  // Actions
  actions: {
    new_invoice: 'สร้างใบแจ้งหนี้',
    create_invoice: 'สร้างใบแจ้งหนี้',
    edit_invoice: 'แก้ไขใบแจ้งหนี้',
    update_invoice: 'อัปเดตใบแจ้งหนี้',
    add_item: 'เพิ่มรายการ',
    generate: 'ออกใบแจ้งหนี้',
    back_to_invoices: 'กลับไปใบแจ้งหนี้',
    back_to_invoice: 'กลับไปที่ใบแจ้งหนี้',
    download_pdf: 'ดาวน์โหลด PDF',
    print_selected: 'พิมพ์ที่เลือก ({{count}})',
    print_all: 'พิมพ์ทั้งหมด',
    print_all_description: 'สร้างใบแจ้งหนี้สำหรับรายการทั้งหมด {{count}} รายการ และเปิดเป็น PDF ในแท็บใหม่',
    create_parking_invoice: 'สร้างใบแจ้งหนี้ค่าจอดรถ',
    sign: 'ลงนามใบแจ้งหนี้',
    re_sign: 'ลงนามใหม่',
    download_signed_pdf: 'ดาวน์โหลด PDF ที่ลงนามแล้ว',
    download_csv: 'ดาวน์โหลด CSV',
    preview_pdf: 'แสดงตัวอย่าง PDF',
  },

  // EP-56 L5 — CSV export column headers
  csv: {
    key: 'รหัส',
    description: 'รายละเอียด',
    type: 'ประเภท',
    quantity: 'จำนวน',
    unit_price: 'ราคา/หน่วย',
    amount: 'รวม',
    total: 'ยอดรวมทั้งหมด',
    percentage_basis: '{{rate}}% ของยอดรวม',
  },

  // External parker
  external_parker_invoice: 'ใบแจ้งหนี้ค่าจอดรถ',

  // Print dialog
  print: {
    title: 'พิมพ์ใบแจ้งหนี้',
    generate: 'สร้าง PDF',
    generating: 'กำลังสร้าง...',
  },

  // Items table
  items: {
    title: 'รายการในใบแจ้งหนี้',
    description: 'รายละเอียด',
    type: 'ประเภท',
    // F16/AC-10 (EP-158): the mobile card heading for a single line item —
    // was reusing `type` + an index, reading "ประเภท 1" (type 1).
    item_label: 'รายการที่ {{n}}',
    quantity: 'จำนวน',
    unit_price: 'ราคาต่อหน่วย',
    amount: 'จำนวนเงิน',
    percentage_basis: '{{rate}}% ของยอดรวม',
  },

  // Detail
  detail: {
    title: 'รายละเอียดใบแจ้งหนี้',
    billed_for_period: 'ออกเมื่อ {{date}} สำหรับงวด {{period}}',
  },

  // Form
  form: {
    title_new: 'สร้างใบแจ้งหนี้',
    title_edit: 'แก้ไขใบแจ้งหนี้',
    description_new: 'สร้างใบแจ้งหนี้ใหม่',
    description_edit: 'แก้ไขรายละเอียดใบแจ้งหนี้',
    invoice_details: 'รายละเอียดใบแจ้งหนี้',
    select_lease: 'ค้นหาสัญญาเช่า...',
    default_rent_description: 'ค่าเช่ารายเดือน',
    loading_pricing: 'กำลังโหลดรายการ...',
    error_zero_total: 'ยอดรวมใบแจ้งหนี้ต้องไม่เป็นศูนย์ กรุณาแก้ไขรายการ',
    metered_zero_qty_hint: 'เพิ่มค่ามิเตอร์ปัจจุบันเพื่อคำนวณการใช้งานอัตโนมัติ',
    // MON-8 E / T149-100: non-blocking, shown when the due date precedes billed_at.
    due_before_issue_warning: 'วันครบกำหนดอยู่ก่อนวันที่ออกใบแจ้งหนี้',
    // T149-022 (LSE-7 decision A): owner-decided copy, verbatim.
    restricted_edit_notice: 'แก้ไขได้เฉพาะวันที่และงวดบิล รายการและยอดรวมแก้ไขไม่ได้',
    sections: {
      advanced: 'รายการสินค้า (สร้างอัตโนมัติ)',
    },
  },

  // Filters
  filters: {
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
    all_periods: 'ทั้งหมด',
    custom_range: 'กำหนดเอง',
    search_placeholder: 'ค้นหาเลขที่ใบแจ้งหนี้...',
  },

  // Setup guide
  setup_guide: {
    title: 'เริ่มต้นออกใบแจ้งหนี้',
    description: 'สร้างใบแจ้งหนี้เพื่อติดตามการเรียกเก็บเงินและการชำระเงินของผู้เช่า',
    prereq_lease: 'มีสัญญาเช่าที่ใช้งานอยู่อย่างน้อย 1 รายการ',
    prereq_setup_lease: 'สร้างสัญญาเช่า',
    prerequisites_title: 'ก่อนเริ่มต้น',
    step_1_title: 'สร้างใบแจ้งหนี้',
    step_1_description: 'เลือกสัญญาเช่าและเพิ่มรายการเรียกเก็บ เช่น ค่าเช่า ค่าน้ำ และค่าไฟ',
    step_2_title: 'บันทึกการชำระเงิน',
    step_2_description: 'ติดตามการชำระเงินเมื่อผู้เช่าจ่ายบิล',
    step_3_title: 'ออกใบแจ้งหนี้แบบกลุ่ม',
    step_3_description: 'ใช้การออกแบบกลุ่มเพื่อสร้างใบแจ้งหนี้สำหรับสัญญาเช่าทั้งหมดในครั้งเดียว',
    preview_sample: 'ดูตัวอย่างใบแจ้งหนี้',
    import: 'นำเข้าจากไฟล์',
    import_off_scope_warning: 'พบ {{count}} แถว {{entity}} นำเข้าจากหน้า {{Entity}}',
    download_sample: 'ดาวน์โหลดตัวอย่าง',
    seed_sample: 'เพิ่มข้อมูลตัวอย่าง',
    seed_sample_confirm: 'ระบบจะสร้าง: อสังหาริมทรัพย์ + ห้อง + ลูกค้า + สัญญาเช่า + ใบแจ้งหนี้ + การชำระเงิน ต้องการดำเนินการต่อหรือไม่?',
    seed_sample_success: 'สร้างข้อมูลตัวอย่าง (ครบทุกรายการ) สำเร็จ',
    seed_sample_noop: 'มีใบแจ้งหนี้อยู่แล้ว ไม่ได้เพิ่มข้อมูลตัวอย่าง',
  },

  // Empty
  empty: {
    title: 'ไม่พบใบแจ้งหนี้',
    description: 'สร้างใบแจ้งหนี้แรกของคุณ',
    not_found: 'ไม่พบใบแจ้งหนี้',
    // B-017: ใบแจ้งหนี้มีอยู่ในบัญชีแต่ตัวกรอง (อสังหาฯ/สถานะ/วันที่) ไม่ตรง
    no_match_title: 'ไม่มีใบแจ้งหนี้ที่ตรงกับตัวกรอง',
    no_match_description: 'ลองล้างตัวกรองอสังหาริมทรัพย์ สถานะ หรือวันที่ เพื่อดูใบแจ้งหนี้ทั้งหมด',
    clear_filters: 'ล้างตัวกรอง',
  },

  // Messages
  messages: {
    delete_confirm: 'ลบใบแจ้งหนี้นี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    error_loading: 'เกิดข้อผิดพลาดในการโหลดใบแจ้งหนี้',
    error_description: 'เกิดข้อผิดพลาดในการโหลดรายการใบแจ้งหนี้',
    // T149-022 (LSE-7): owner-decided copy, verbatim.
    cannot_edit_paid: 'ใบแจ้งหนี้นี้มีการชำระเงินแล้ว ไม่สามารถแก้ไขได้',
    sign_success: 'ลงนามใบแจ้งหนี้เรียบร้อยแล้ว',
    signed_stale: 'ใบแจ้งหนี้ถูกแก้ไขหลังจากเซ็นแล้ว PDF ที่เซ็นอาจไม่เป็นปัจจุบัน',
    signed_stale_badge: 'ไม่เป็นปัจจุบัน',
    no_invoice_template: 'ไม่พบเทมเพลตใบแจ้งหนี้ กรุณาตั้งค่าใน "ตั้งค่า → เทมเพลต"',
  },

  // Wizard preview
  preview: {
    draft_number: 'ฉบับร่าง (ตัวอย่าง)',
  },

  // Tax invoice
  tax_invoice: {
    title: 'ใบกำกับภาษี',
    number: 'เลขที่ใบกำกับภาษี',
    date: 'วันที่ใบกำกับภาษี',
    generate: 'ออกใบกำกับภาษี',
    generate_confirm: 'ออกใบกำกับภาษีสำหรับใบแจ้งหนี้นี้? ระบบจะกำหนดเลขที่ใบกำกับภาษีและไม่สามารถแก้ไขได้',
    already_generated: 'ออกใบกำกับภาษีแล้ว',
    no_tax_id: 'กรุณาตั้งค่าเลขประจำตัวผู้เสียภาษีในการตั้งค่าก่อนออกใบกำกับภาษี',
    no_tax_id_hint: 'ต้องระบุเลขประจำตัวผู้เสียภาษีก่อนออกใบกำกับภาษี คลิกเพื่อไปที่ตั้งค่า → บัญชี แล้วกรอกเลข 13 หลัก',
    seller_section: 'ข้อมูลผู้ขาย',
    buyer_section: 'ข้อมูลผู้ซื้อ',
    seller_name: 'ชื่อ',
    seller_tax_id: 'เลขประจำตัวผู้เสียภาษี',
    seller_address: 'ที่อยู่',
    seller_branch: 'รหัสสาขา',
    buyer_name: 'ชื่อ',
    buyer_tax_id: 'เลขประจำตัวผู้เสียภาษี',
    buyer_address: 'ที่อยู่',
    download_pdf: 'ดาวน์โหลด PDF',
    preview_pdf: 'ดูตัวอย่าง PDF',
    vat_changed: 'การตั้งค่าภาษีมูลค่าเพิ่มมีการเปลี่ยนแปลง กรุณาสร้างใบกำกับภาษีใหม่',
    regenerate_pdf: 'สร้าง PDF ใหม่',
  },

  // Sign modal
  sign_modal: {
    description: 'วาดลายเซ็นด้านล่างเพื่อเซ็นใบแจ้งหนี้',
    generating: 'กำลังสร้าง PDF...',
    signing: 'กำลังเซ็น...',
    progress: 'กำลังเซ็น {{current}} จาก {{total}}...',
  },

  // Bulk actions
  bulk: {
    select_all: 'เลือกทั้งหมด',
    selected_count: 'เลือก {{count}} รายการ',
    sign: 'เซ็น',
    sign_success: 'เซ็นใบแจ้งหนี้ {{count}} รายการสำเร็จ',
    sign_partial: 'เซ็นได้ {{count}} จาก {{total}} รายการ (บางรายการล้มเหลว)',
    clear_selection: 'ยกเลิกเลือก',
  },

  // Batch generation
  batch: {
    title: 'ออกใบแจ้งหนี้',
    description: 'ออกใบแจ้งหนี้สำหรับสัญญาเช่าทั้งหมดที่ใช้งานอยู่',
    period: 'รอบบิล',
    due_date: 'วันครบกำหนด',
    preview: 'ดูตัวอย่าง',
    generate: 'ออกทั้งหมด',
    generate_confirm: 'ออกใบแจ้งหนี้ {{count}} รายการ?',
    missing_readings: 'ยังไม่ได้จดมิเตอร์',
    negative_usage: 'หน่วยใช้ติดลบ',
    move_in_marker: 'ย้ายเข้า {{date}}',
    move_out_marker: 'ย้ายออก {{date}}',
    full_month_caption: 'คิดเต็มเดือน ไม่เฉลี่ยตามจำนวนวัน หากต้องการปรับยอด ให้ยกเลิกเลือกสัญญานี้และออกใบแจ้งหนี้เอง',
    select_lease: 'เลือก {{lease}}',
    total_leases: 'สัญญาทั้งหมด',
    total_amount: 'ยอดรวม',
    no_active_leases: 'ไม่พบสัญญาเช่าที่ใช้งานอยู่ในรอบนี้',
    already_invoiced: 'มีใบแจ้งหนี้แล้ว',
    already_invoiced_count: 'มีใบแจ้งหนี้แล้ว {{count}} รายการ',
    to_generate: 'รอออกใบ {{count}} รายการ',
    // F4: selective batch generation
    generate_selected_one: 'ออก {{count}} ใบแจ้งหนี้',
    generate_selected_other: 'ออก {{count}} ใบแจ้งหนี้',
    selected_summary: 'เลือก {{count}} จาก {{eligible}} · {{total}}',
    no_selection_disabled_hint: 'เลือกอย่างน้อย 1 สัญญาเช่าเพื่อเปิดใช้งาน',
    clear_selection: 'รีเซ็ตเป็นทั้งหมด',
    // EP-149 T149-016 (MON-8): due-date override toggle, the per-row due date
    // column, and the past-due warning banner.
    override_due_date_toggle: 'กำหนดวันครบกำหนดเอง',
    due_date_column: 'วันครบกำหนด',
    due_date_warning_title: 'ใบแจ้งหนี้เกินกำหนดชำระ',
    due_date_warning_body: 'ใบแจ้งหนี้บางรายการเกินกำหนดชำระแล้ว',
    due_date_warning_late_fee: 'ค่าปรับล่าช้าเริ่มนับจาก {{date}}',
    keep_dates: 'คงวันเดิม',
    push_days_label: 'เลื่อนเป็นวันที่ออก +',
    push_days_suffix: 'วัน',
    push_days_apply: 'ใช้',
    // MON-8 E / T149-100: shown next to the override due-date input.
    due_before_issue_warning: 'วันครบกำหนดอยู่ก่อนวันที่ออกใบแจ้งหนี้',
  },

  // Server-side error codes (returned in error.code by the API).
  errors: {
    missing_lease_or_customer: 'ใบแจ้งหนี้ต้องผูกกับสัญญาเช่าหรือลูกค้าอย่างน้อยหนึ่งรายการ',
    // T149-021/T149-022 (LSE-7): the three 422 codes invoices_controller.rb
    // returns on a paid invoice's PATCH.
    cannot_edit_paid_invoice: 'เจ้าของบัญชีเท่านั้นที่แก้ไขใบแจ้งหนี้ที่มีการชำระเงินแล้วได้',
    cannot_edit_amounts_on_paid_invoice: 'แก้ไขได้เฉพาะวันที่ออกใบแจ้งหนี้ วันครบกำหนด และงวดบิลเท่านั้น',
    invoice_repost_failed: 'บันทึกใบแจ้งหนี้ไม่สำเร็จ เนื่องจากลงบันทึกบัญชีใหม่ไม่สำเร็จ',
    validation_failed: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบแบบฟอร์มอีกครั้ง',

    // Per-field labels used when error.details points at specific fields.
    fields: {
      description: 'รายละเอียด',
      item_type: 'ประเภทรายการ',
      quantity: 'จำนวน',
      unit_price: 'ราคาต่อหน่วย',
      amount: 'จำนวนเงิน',
      lease: 'สัญญาเช่า',
      lease_id: 'สัญญาเช่า',
      customer: 'ลูกค้า',
      customer_id: 'ลูกค้า',
      billed_at: 'วันที่ออกใบแจ้งหนี้',
      due_at: 'วันครบกำหนด',
      total: 'ยอดรวม',
    },

    // Rails AR error codes (the symbols inside record.errors.details).
    codes: {
      blank: 'ต้องไม่เว้นว่าง',
      taken: 'ถูกใช้แล้ว',
      invalid: 'ไม่ถูกต้อง',
      too_short: 'สั้นเกินไป',
      too_long: 'ยาวเกินไป',
      greater_than: 'ต้องมากกว่าค่าที่กำหนด',
      greater_than_or_equal_to: 'ต้องมากกว่าหรือเท่ากับค่าที่กำหนด',
      less_than: 'ต้องน้อยกว่าค่าที่กำหนด',
      less_than_or_equal_to: 'ต้องน้อยกว่าหรือเท่ากับค่าที่กำหนด',
      not_a_number: 'ต้องเป็นตัวเลข',
      inclusion: 'ค่าไม่อยู่ในรายการที่อนุญาต',
      exclusion: 'ค่านี้ไม่อนุญาต',
      confirmation: 'ไม่ตรงกับการยืนยัน',
    },
  },
}
